import React, { ChangeEvent, FC, useState, useEffect } from 'react';
import { ContentWrapperWidget, MainTemplate } from '../../components/layouts';
import { useRefereeByIdLazyQuery, CreateRefereeMutationHookResult, useCreateRefereeMutation } from '../../api';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Typography,
  withStyles,
} from '@material-ui/core';
import { useRouteMatch } from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { blue } from '@material-ui/core/colors';
import moment from 'moment';
import _get from 'lodash/get';
import AdditionalInfo from '../../components/widgets/Persons/AdditionalInfo';
import MainInfo from '../../components/widgets/Persons/MainInfo';
import Duplicates from '../../components/widgets/Persons/Duplicates';
import Citizenship from '../../components/widgets/Persons/Citizenship';
import RefereeCategory from '../../components/widgets/Referees/RefereeCategory';
import { useHistory } from 'react-router';
type AccordionTypes = 'MainInfo' | 'Citizenship' | 'AdditionalInfo' | 'Duplicates' | 'RefereeCategory' | undefined;

const AccordionSummary = withStyles({
  root: {
    backgroundColor: blue[700],
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    color: 'white',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

// @TODO: Update View for Dialog request to Archive

const Single: FC<{}> = () => {
  const {
    params: { id },
  } = useRouteMatch();
  // const [page, setPage] = useState<number>(0);
  const { push } = useHistory();
  const [expanded, setExpanded] = useState<AccordionTypes>('MainInfo');
  const [create]: CreateRefereeMutationHookResult = useCreateRefereeMutation();
  // const access = usePermission('directory', 'person');
  // const style = useStyle();
  // const canAdd = true;
  const [fetch, { data, loading }] = useRefereeByIdLazyQuery({ variables: { id } });

  const handleChangeAccordion = (panel: AccordionTypes) => (event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : undefined);
  };

  useEffect(() => {
    if (id !== 'new' && id !== '') {
      fetch({ variables: { id } });
    }
  }, [id]);

  return (
    <MainTemplate pageName="" url="">
      <ContentWrapperWidget>
        {id === 'new' ? (
          <h2>Добавить новый судья</h2>
        ) : (
          <h2>
            Судь: {data?.dirReferee?.dirPerson?.lastname} {data?.dirReferee?.dirPerson?.firstname}
            {_get(data?.dirReferee?.dirPerson, 'patronymic', '')}
            &nbsp;{moment(data?.dirReferee?.dirPerson?.birthday).format('DD.MM.YYYY')}
          </h2>
        )}
        <Accordion expanded={expanded === 'MainInfo'} onChange={handleChangeAccordion('MainInfo')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Общая информация</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MainInfo
              id={data?.dirReferee?.dirPerson?.id || 'new'}
              onUpdate={async (idPerson) => {
                if (id === 'new') {
                  const referee = await create({ variables: { idPerson } });
                  push(`/referee/${referee?.data?.createDirReferee?.id}`);
                }
              }}
            />
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'AdditionalInfo'}
          onChange={handleChangeAccordion('AdditionalInfo')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Дополнительная информация</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {data?.dirReferee?.dirPerson?.id && <AdditionalInfo id={data?.dirReferee?.dirPerson.id} />}
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'Citizenship'}
          onChange={handleChangeAccordion('Citizenship')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Гражданство</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {data?.dirReferee?.dirPerson?.id && <Citizenship id={data?.dirReferee?.dirPerson.id} />}
          </AccordionDetails>
        </Accordion>

        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'Duplicates'}
          onChange={handleChangeAccordion('Duplicates')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Дубликаты</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {data?.dirReferee?.dirPerson?.id && <Duplicates id={data?.dirReferee?.dirPerson?.id} />}
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'RefereeCategory'}
          onChange={handleChangeAccordion('RefereeCategory')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Судейская категория</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <RefereeCategory id={id} />
          </AccordionDetails>
        </Accordion>
      </ContentWrapperWidget>
    </MainTemplate>
  );
};

export default Single;
